import React from "react";
import VerifiedCompetencySubmissionForm from "../../features/VerifiedCompetency/VerifiedCompetencySubmissionForm";


const VerifiedCompetencySubmission = () =>
{
  return (
    <>
      <VerifiedCompetencySubmissionForm />
    </>
  );
};

export default VerifiedCompetencySubmission;
